export default "__VITE_ASSET__7fd1591b__"